import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, message } from 'antd';
import gql from 'graphql-tag';
import { useState } from 'react';
import { iBuildVideoOptions } from 'shared/video';
import { useAuthedMutationWithNotification } from 'utils/qlAuth';

export const StoryTimelineController_buildVideo = (props: { qStory: any; storyId: number; opt?: iBuildVideoOptions }) => {
  const [inLoading, setInLoading] = useState(false);

  const [buildVideo] = useAuthedMutationWithNotification(gql`
    mutation StoryTimelineController_buildVideo($storyId: Int!, $opt: JSON) {
      StoryTimelineController_buildVideo(storyId: $storyId, opt: $opt) {
        success
        message
      }
    }
  `);

  const opt = {
    allFiles: true, // Собрать все файлы, включая аудио из папки
    ...(props.opt || {}), // Расширяем опции из props
  };

  return (
    <Button
      disabled={inLoading}
      size="small"
      onClick={async () => {
        Modal.confirm({
          title: `Собрать видео?`,
          icon: <ExclamationCircleOutlined />,
          content: `Будет запущена сборка видео для этой истории.`,
          onOk: async () => {
            try {
              setInLoading(true);
              message.info('Сборка видео запущена');
              const res = await buildVideo({ variables: { storyId: Number(props.storyId), opt: opt } });
              const data = res.data?.StoryTimelineController_buildVideo;
              if (data && data.success) {
                setInLoading(false);
                message.success('Сборка видео завершена');
              } else {
                message.error('Не удалось запустить сборку видео');
                setInLoading(false);
                return;
              }

              setInLoading(false);
            } catch (e) {
              console.log(e);
              setInLoading(false);
            }
          },
        });
      }}
    >
      Build video
    </Button>
  );
};
